/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { cached } from '@glimmer/tracking';
import { type BsFormSignature } from 'ember-bootstrap/components/bs-form';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { SyncType } from 'uplisting-frontend/components/ui/stay-strategy/v1';

interface IArgs {
  form: BsFormSignature<
    ModelRegistry['bulk-mlos'] | ModelRegistry['bulk-rate']
  >;
  isBulk?: boolean;
  syncType?: SyncType;
  icon: 'bolt' | 'calendar-days';
  iconPrefix?: 'far' | 'fas';
}

interface StayStrategyV1NumericSignature {
  Element: HTMLDivElement;

  Args: IArgs;
}

export default class UiStayStrategyV1NumericComponent extends Component<StayStrategyV1NumericSignature> {
  @cached
  get currency(): string {
    return this.args.form.model.properties?.[0]?.currency ?? 'USD';
  }

  @cached
  get isPrices(): boolean {
    return this.args.syncType === SyncType.prices;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::StayStrategy::V1::Numeric': typeof UiStayStrategyV1NumericComponent;
  }
}
